export default __webpack_public_path__ + "static/media/icon_mydata_china.b7fa3231.svg";